<template>
    <v-container fluid class="pt-0">
        <confirm-delete
            :is-open="isConfirmDeleteDialogVisible"
            :selected="selected"
            @confirm="onConfirmDeleteDialog"
            @close="onCloseConfirmDeleteDialog"
        />
        <v-row>
            <v-col cols="12" md="6">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <h2
                                    >{{
                                        $t(
                                            'dashboardView.listOfEndingContractsTitle'
                                        )
                                    }}
                                </h2>
                            </v-col>
                        </v-row>
                        <contract-list
                            :contracts="endingContracts"
                            :visibilityConfig="{
                                search: false,
                                refresh: true,
                                excludeHeaders: [
                                    'position',
                                    'calculatedDaysOff',
                                    'status',
                                    'action'
                                ]
                            }"
                            @refresh="onRefreshEndingContracts"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <h2
                                    >{{
                                        $t(
                                            'dashboardView.listOfNotConfirmedVacationsTitle'
                                        )
                                    }}
                                </h2>
                            </v-col>
                        </v-row>
                        <vacation-request-list
                            :vacations="notConfirmedVacations"
                            :visibilityConfig="{
                                actions: {
                                    edit: false,
                                    confirm: true,
                                    delete: true
                                },
                                search: false,
                                refresh: true,
                                excludeHeaders: ['isConfirmed']
                            }"
                            @confirm="onConfirmVacationRequest"
                            @delete="onDeleteItem"
                            @refresh="onRefreshVacations"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'adminDashboard',

    components: {
        ContractList: () => import('@/components/ContractList'),
        VacationRequestList: () => import('@/components/VacationRequestList'),
        ConfirmDelete: () => import('@/components/ConfirmDelete')
    },

    data() {
        return {
            isConfirmDeleteDialogVisible: false,
            selected: null
        };
    },

    computed: {
        ...mapGetters({
            endingContracts: 'contracts/getEndingContracts',
            notConfirmedVacations: 'vacations/getNotConfirmedVacations'
        })
    },

    async created() {
        await this.fetchNotConfirmedVacations();
        await this.fetchEndingContracts();
    },

    methods: {
        ...mapActions({
            fetchEndingContracts: 'contracts/fetchEnding',
            fetchNotConfirmedVacations: 'vacations/fetchNotConfirmed',
            confirmVacation: 'vacations/confirm',
            deleteVacation: 'vacations/delete'
        }),

        onDeleteItem(item = {}) {
            this.selected = item;
            this.isConfirmDeleteDialogVisible = true;
        },
        async onConfirmDeleteDialog(item) {
            try {
                await this.deleteVacation(item.id);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('vacationRequestsView.vacationTitle'),
                    text: this.$t('vacationRequestsView.deleteSuccess')
                });
            } catch (error) {
                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: this.$t('vacationRequestsView.vacationTitle'),
                    text: this.$t('vacationRequestsView.deleteError')
                });

                console.error(error);
            }

            this.onCloseConfirmDeleteDialog();
        },
        onCloseConfirmDeleteDialog() {
            this.selected = null;
            this.isConfirmDeleteDialogVisible = false;
        },
        async onConfirmVacationRequest(item) {
            try {
                await this.confirmVacation(item.id);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('createOrUpdateVacation.vacationTitle'),
                    text: this.$t('createOrUpdateVacation.confirmSuccess')
                });
            } catch (err) {
                if (err.response && err.response.status === 404) {
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t('createOrUpdateVacation.editTitle'),
                        text: this.$t(
                            'createOrUpdateVacation.vacationDoesntExist'
                        )
                    });
                }

                console.error(err);
            }
        },
        async onRefreshVacations() {
            await this.fetchNotConfirmedVacations();
        },
        async onRefreshEndingContracts() {
            await this.fetchEndingContracts();
        }
    }
};
</script>
